// extracted by mini-css-extract-plugin
module.exports = {"container":"Spinner_container__1olYK","loader":"Spinner_loader__LqfCx","load4":"Spinner_load4__304WW"};